import { api } from 'api'
import { useQuery } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useExportFaq = () => {
  const response = useQuery({
    queryKey: ['faqExport'],
    queryFn: () => api.faq.export(),
    gcTime: 0,
    enabled: false,
  })

  if (response.isError) {
    toaster.create({
      type: 'error',
      title: 'Произошла ошибка при скачивании файла',
      description: (response.error as any)?.response?.data?.message || response.error?.message,
    })
  }

  if (response.isSuccess && response.data) {
    // Создаем blob с данными в формате JSON
    const blob = new Blob([JSON.stringify(response.data, null, 2)], {
      type: 'application/json'
    })
    
    // Создаем URL для blob
    const url = window.URL.createObjectURL(blob)
    
    // Создаем временную ссылку для скачивания
    const link = document.createElement('a')
    link.href = url
    link.download = 'faq-data.txt'
    
    // Добавляем ссылку в DOM, кликаем по ней и удаляем
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    
    // Освобождаем URL
    window.URL.revokeObjectURL(url)

    toaster.create({
      type: 'success',
      title: 'Файл успешно экспортирован',
    })
  }

  return response
}
